exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-privacy-policy-js": () => import("./../../../src/pages/app-privacy-policy.js" /* webpackChunkName: "component---src-pages-app-privacy-policy-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-questions-js": () => import("./../../../src/pages/questions.js" /* webpackChunkName: "component---src-pages-questions-js" */),
  "component---src-pages-statement-js": () => import("./../../../src/pages/statement.js" /* webpackChunkName: "component---src-pages-statement-js" */)
}

